export type BaceApp = "app" | "dashboard" | "admin";
export type BaceBackend = "api" | "auth";

const DEV_PORTS: Record<BaceApp, string> = {
	app: "7500",
	dashboard: "7300",
	admin: "7400",
};

const FRONTEND_HOSTNAME = /^(?:pr-\d+-)?(?:app|dashboard|admin)(?:-staging)?\.(.+)$/;

export function originForApp(target: BaceApp, origin: string = location.origin): string {
	try {
		const url = new URL(origin);

		if (url.hostname === "localhost" || url.hostname === "127.0.0.1") {
			url.port = DEV_PORTS[target];
			return url.origin;
		}

		url.hostname = url.hostname.replace(/(^|-)(app|dashboard|admin)(?=(-staging)?\.)/, `$1${target}`);
		return url.origin;
	} catch {
		return origin;
	}
}

export function originForBackend(target: BaceBackend, configuredOrigin?: string, origin: string = location.origin): string | undefined {
	try {
		const url = new URL(origin);

		if (url.hostname === "localhost" || url.hostname === "127.0.0.1") {
			return configuredOrigin;
		}

		const domain = url.hostname.match(FRONTEND_HOSTNAME)?.[1];
		if (!domain) {
			return configuredOrigin;
		}

		url.hostname = `${target}.${domain}`;
		url.port = "";
		return url.origin;
	} catch {
		return configuredOrigin;
	}
}
